import classnames from "classnames"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import * as R from "ramda"
import React from "react"

import styles from "./radiobutton.less"

export default createReactClass({
  propTypes: {
    id: PropTypes.string,
    dataQa: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    isChecked: PropTypes.bool,
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    title: PropTypes.string,
    html: PropTypes.bool,
    readable: PropTypes.bool,
    autoFocus: PropTypes.bool,
    role: PropTypes.string,
    tabindex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  },
  getInitialState() {
    // Must be per-instance: a createRef() on the createReactClass spec is shared
    // across all radios, so current can become null when another instance unmounts.
    this.inputRef = React.createRef()
    return {}
  },
  changeCheckedState() {
    this.onClick()
    this.onChange()
  },
  onChange() {
    const input = this.inputRef && this.inputRef.current
    if (!input) {
      return
    }

    if (typeof this.props.onChange == "function") {
      this.props.onChange(input, input.checked)
    }
  },
  onClick() {
    const input = this.inputRef && this.inputRef.current
    if (!input) {
      return
    }

    if (typeof this.props.onClick == "function") {
      this.props.onClick(input, input.checked)
    }
  },
  getClass() {
    return classnames(styles.radio, this.props.className)
  },
  getLabelClass() {
    return classnames(
      {
        [styles.checked]: this.props.isChecked,
        [styles.disabled]: this.props.isDisabled,
        "readspeaker-readable-area": this.props.readable,
      },
      this.props.labelClassName,
    )
  },
  render() {
    const radioId = R.isNil(this.props.id)
      ? Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      : this.props.id

    let content = null

    if (this.props.children != null) {
      content = this.props.children
    } else if (this.props.title != null && this.props.html) {
      content = <span dangerouslySetInnerHTML={{ __html: this.props.title }} />
    } else if (this.props.title != null) {
      content = this.props.title
    }

    return (
      <div
        className={this.getClass()}
        role={this.props.role || "radio"}
        tabIndex={this.props.tabindex || "0"}
        aria-checked={this.props.isChecked}
        onKeyPress={(e) => {
          if (e.keyCode === 0) this.changeCheckedState(e)
        }}>
        <label
          className={this.getLabelClass()}
          data-qa={this.props.dataQa ? `label-${this.props.dataQa}` : undefined}
          htmlFor={radioId}>
          {content}
        </label>
        <input
          className="rs_preserve"
          type="radio"
          id={radioId}
          data-qa={this.props.dataQa}
          onChange={this.onChange}
          onClick={this.onClick}
          checked={this.props.isChecked}
          disabled={this.props.isDisabled}
          autoFocus={this.props.autoFocus}
          ref={this.inputRef}
        />
      </div>
    )
  },
})
